import { Component, inject, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { ClipboardService } from '../../services/clipboard-service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LangService } from '../../services/lang/lang.service';

@Component({
  selector: 'app-copy-button',
  imports: [MatIcon, MatButtonModule, MatTooltipModule],
  templateUrl: './copy-button.component.html',
  styleUrl: './copy-button.component.scss',
})
export class CopyButtonComponent {
  private clipboardService = inject(ClipboardService);
  labels = inject(LangService).lang.shared.clipboard;

  value = input<string | null | undefined>('');

  onClick(event: MouseEvent) {
    event.stopPropagation();
    this.clipboardService.copyToClipboard(this.value() ?? '');
  }
}
